import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=0dc561b2&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=ts&"
export * from "./Team.vue?vue&type=script&lang=ts&"
import style0 from "./Team.vue?vue&type=style&index=0&id=0dc561b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc561b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc561b2')) {
      api.createRecord('0dc561b2', component.options)
    } else {
      api.reload('0dc561b2', component.options)
    }
    module.hot.accept("./Team.vue?vue&type=template&id=0dc561b2&scoped=true&", function () {
      api.rerender('0dc561b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Team.vue"
export default component.exports